import { render, staticRenderFns } from "./ChargingPointConfigurationBatches.vue?vue&type=template&id=3941580a&scoped=true"
import script from "./ChargingPointConfigurationBatches.vue?vue&type=script&lang=js"
export * from "./ChargingPointConfigurationBatches.vue?vue&type=script&lang=js"
import style0 from "./ChargingPointConfigurationBatches.vue?vue&type=style&index=0&id=3941580a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3941580a",
  null
  
)

export default component.exports